export function getDate(offset = 0) {
  const date = new Date();
  return new Date(date.setDate(date.getDate() + offset)); 
}